import React, { useContext } from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { CollapsedContext } from "../../../Context/CollapsedContext";
import LogoImg from "../../Components/assets/logo_white.png";

const LogoDiv = styled.div`
  display: flex;
  width: 300px;
  height: 80px;
  justify-content: flex-start;
  align-items: center;
`;

const ImgTag = styled.img`
  width: 55px;
  height: 55px;
`;

const LogoTitle = styled.div`
  color: white;
  font-size: 18px;
  text-align: center;
`;

const Logo = () => {
  const { collapsed, onCollapse } = useContext(CollapsedContext);
  const navigate = useNavigate();

  const goHome = (e) => {
    if (collapsed == false) {
      onCollapse();
    }

    navigate("/HOME");
  };

  return (
    <LogoDiv onClick={goHome}>
      <LogoTitle>스마트 낙농단지</LogoTitle>
      <img
        src={LogoImg}
        width="120px"
        style={{ position: "absolute", top: "10px" }}
      />
    </LogoDiv>
  );
};

export default Logo;
